import { Service } from 'typedi';
import { axios } from '../axios';

@Service()
export class ConfirmationRequest {
  answerMeeting(isAccept: boolean, meetingId: string, consumerId: string, isOuter = false) {
    const query = `meetingId=${meetingId}&consumerId=${consumerId}`
    const url = `user/answer/${isOuter ? 'outer/' : ''}${isAccept ? 'accept' : 'cancel'}?${query}`;

    return axios.get(url);
  }


  offerTime(meetingHash: string, userHash: string, date: Date) {
    return axios.post('user/answer/offer/time', { 
      meetingId: meetingHash, 
      userId: userHash, 
      offeredTime: [date.getHours(), date.getMinutes(), 0, 0],
    })
  }
}
